<template>
  <MarketCard class="market-insights">
    <div :class="classes.cardHeader">
      <CardHeader :class="classes.datesport" :eventId="eventId" />
    </div>

    <div :class="classes.cardContent">
      <EventNames
        :class="classes.leftContent"
        :eventId="eventId"
        :marketId="marketId"
      />

      <div :class="classes.insightWrapper">
        <div :class="classes.insightText">
          <PromoFittedText
            :promoText="insightText"
            alignment="center"
          ></PromoFittedText>
        </div>

        <MarketName :class="classes.marketName" :marketId="marketId" />

        <div :class="classes.oddsButtonWrapper">
          <template v-if="relevantOption">
            <RelevantButton
              :class="[classes.oddsButton]"
              :option="relevantOption"
              :eventId="eventId"
            />
          </template>
          <template v-else>
            <Button
              :stagger="0"
              :class="[classes.oddsButton]"
              :option="firstOption"
            />
            <Button
              :stagger="2"
              :class="[classes.oddsButton]"
              :option="secondOption"
            />
          </template>
        </div>
      </div>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, computed, ComputedRef } from "vue";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import Button from "../Button.vue";
import EventNames from "../../../EventNamesBadgesStacked.vue";
import MarketCard from "../../../styled/MarketCard.vue";
import CardHeader from "../../../CardHeaderLeaderboard.vue";
import PromoFittedText from "../../../PromoFittedText.vue";
import MarketName from "../../../MarketName.vue";

import { useInsightData } from "../../../../hooks/useInsightData";
import RelevantButton from "../RelevantButton.vue";
import { Option } from "@fresh8/types/src/betData";

const useStyles = createUseStyles({
  cardHeader: {
    position: "absolute",
    width: "40%"
  },

  datesport: {
    "& span": {
      fontSize: "10px !important"
    }
  },
  marketName: {
    margin: "0 8px",
    display: "flex",
    justifyContent: "space-evenly"
  },

  cardContent: {
    display: "flex",
    flex: 1
  },

  leftContent: {
    margin: "17px 0 6px",
    paddingTop: "6px",
    paddingBottom: "6px"
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    flex: 1
  },
  insightWrapper: {
    flex: "1 0 50%",
    padding: "6px",
    display: "flex",
    overflow: "hidden",
    boxSizing: "border-box",
    minHeight: "0px",
    flexDirection: "column",
    borderLeft: props => `1px solid ${props.marketBorderColor}`
  },
  insightText: {
    flex: "1 1 0px",
    display: "flex",
    padding: "0 0 3px",
    overflow: "hidden",
    boxSizing: "border-box",
    minHeight: "0px",
    flexDirection: "column"
  },
  oddsButton: {
    flex: 1,

    "& .odds-text": {
      fontSize: "12px"
    },
    "& .relevant-button .name": {
      fontSize: "12px",
      lineHeight: 1
    },
    "&:first-of-type": {
      marginRight: "4px"
    },
    "&:last-of-type": {
      marginLeft: "4px"
    }
  },
  oddsButtonWrapper: {
    display: "flex",
    padding: "4px 0 0"
  },

  resize: {
    pointerEvents: "none",
    zIndex: -99
  }
});

export default defineComponent({
  name: "SmallResponsive",
  components: {
    CardHeader,
    EventNames,
    PromoFittedText,
    Button,
    MarketCard,
    MarketName,
    RelevantButton
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const brand = injectBrand();
    const {
      insightText,
      firstOption,
      secondOption,
      relevantOption
    } = useInsightData(props.marketId);

    const relativeStyles = computed(() => ({
      marketBorderColor: brand?.adTemplateBranding.value.marketBorderColor
    }));

    const classesRef = useStyles(relativeStyles);

    return {
      insightText,
      firstOption: firstOption as ComputedRef<Option>,
      secondOption: secondOption as ComputedRef<Option>,
      relevantOption,
      classes: classesRef
    };
  }
});
</script>
